<template>
  <div style="margin:0px 20px 20px 20px;">
    <div class="steps has-text-centered">
      <a
        v-if="steps.nowStep>1 && type_formulaire === 'simple'"
        :style="window.width<480?'width:100%;margin-top:5px;':''"
        class="button-client is-pulled-left"
        @click="prevStep()"
      >{{$t('question.precedent')}}</a>
      <a
        v-if="steps.nowStep>1 && type_formulaire === 'section' && !viewColidee && sondage_type === 'replay'"
        :style="window.width<480?'width:100%;margin-top:5px;':''"
        class="button-client is-pulled-left"
        @click="prevStep()"
      >{{$t('question.reload')}}</a>

      <a
        v-if="!buttons.localShowButton[steps.nowStep-1] && !steps.authorizedSendForm && !errorMaxCheckboxes"
        :style="window.width<480?'width:100%;margin-top:5px;':''"
        class="button-client is-pulled-right"
        @click="buttons.localShowButton[steps.nowStep-1] ? nextStep() : null"
      >{{$t('question.obligatoire')}}</a>
      <button
        :disabled="errorMaxCheckboxes"
        v-if="!buttons.localShowButton[steps.nowStep-1] && !steps.authorizedSendForm && errorMaxCheckboxes"
        :style="window.width<480?'width:100%;margin-top:5px;':''"
        class="button-client is-pulled-right"
        @click="buttons.localShowButton[steps.nowStep-1] ? nextStep() : null"
      >{{$t('question.suivant')}}</button>
      <a
        v-if="buttons.localShowButton[steps.nowStep-1] && !steps.authorizedSendForm && !errorMaxCheckboxes"
        :style="window.width<480?'width:100%;margin-top:5px;':''"
        class="button-client is-pulled-right"
        @click="buttons.localShowButton[steps.nowStep-1] ? nextStep() : null"
      >{{$t('question.suivant')}}</a>

      <button
        class="is-pulled-right button-client"
        :style="window.width<480?'width:100%;margin-top:5px;':''"
        v-show="steps.authorizedSendForm"
        :class="{'is-loading' : !steps.authorizedVote}"
      >{{$t('common.valider')}}</button>

      <div class="is-clearfix"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default {
  name: 'Buttons',
  props: {
    viewColidee: {
      required: false
    },
    window: {
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    question: {
      required: true
    },
    question_relation_section: {
      type: Number,
      required: false
    },
    question_type: {
      type: String,
      required: false
    },
    sondage_type: {
      required: true
    }
  },
  mounted () {
    EventBus.$on('update_showLocalButton', this.updateShowLocalButton)
    this.updateShowLocalButton()
  },
  beforeDestroy () {
    EventBus.$off('update_showLocalButton')
  },
  computed: {
    ...mapGetters([
      'steps',
      'type_formulaire',
      'buttons',
      'sections',
      'indexConditionalSection',
      'radioAnswerConditonalSection',
      'errorMaxCheckboxes'
    ])
  },
  methods: {
    updateShowLocalButton () {
      this.$store.commit('UPDATE_SHOW_LOCAL_BUTTON', {
        type: this.type_formulaire,
        question_optional: this.question.optional,
        question_relation_section: this.question_relation_section
      })
    },
    nextStep () {
      let next = 'suivant'
      switch (this.type_formulaire) {
        case 'simple':
          this.$store.commit('STEP_NEXT', { type: 'simple', localShowButton: this.buttons.localShowButton })
          break
        case 'section':
          /** question suivante */
          if ((this.radioAnswerConditonalSection === null || this.$store.state.client.radioAnswerConditonalSection === 0) && this.steps.stepsLengthSection.length !== this.steps.nowStepSection + 1) {
            next = 'suivant'
            EventBus.$emit('update_stepsLengthSection', 'suivant')
          } else if (this.radioAnswerConditonalSection !== null || this.steps.stepsLengthSection.length === this.steps.nowStepSection + 1) {
            /** section suivante */
            next = 'section_suivante'
            EventBus.$emit('update_stepsLengthSection', 'section_suivante')
          }
          this.$store.commit('STEP_NEXT', {
            type: 'sections',
            condtionalSection: this.radioAnswerConditonalSection,
            answersLength:
              this.radioAnswerConditonalSection !== null
                ? this.$store.state.question.sections[this.radioAnswerConditonalSection].questions.length
                : null,
            data: this.$store.state.question.sections,
            questionOrder: this.index,
            next: next
          })
          break
      }
    },
    prevStep () {
      // EventBus.$emit('update_resetPreviousStep')
      switch (this.type_formulaire) {
        case 'simple':
          this.$store.commit('STEP_PREVIOUS', {'type': this.type_formulaire, data: this.$store.state.question.sections})
          break
        case 'section':
          EventBus.$emit('resetForm_client')
          break
      }
    }
  }
}
</script>
<style scoped>
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

</style>



// WEBPACK FOOTER //
// src/components/formulaire/buttons/buttons.vue